import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import styles from "components/documents/category-cell.scss";
import { isValidValue } from "utils/validators";
import { ActiveFilterItem } from "components/documents/filters/active-filter-item";

export const VendorRuleCellFormatter = (props) => {
  if (!isValidValue(props.value)) {
    return null;
  }
  return (
    <div className={ styles["active-filter-group"] }>
      {mapRenderItem(props)}
    </div>
  );
};

VendorRuleCellFormatter.defaultProps = {
  value: []
};

VendorRuleCellFormatter.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object)
};

const mapRenderItem = (props) => (
  props.value.map(item => (
    renderItem(props, item)
  ))
);

const renderItem = (props, item) => {
  const rule = R.find(R.propEq("vendorName", props.vendorName))(item.rules.includeVendors);
  return (
    <span key={ `${item.name}-${item.id}` }>
      <ActiveFilterItem
        name={ item.name }
        onRemove={ () => props.onDeleteIncludeRule(props.accountId, item, rule) }
      />
    </span>
  );
};

renderItem.propTypes = {
  accountId: PropTypes.string.isRequired,
  onDeleteIncludeRule: PropTypes.func.isRequired,
  vendorName: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/vendor-rule-cell-formatter.jsx